import { useEffect, useState, useCallback } from 'react'

interface IUseTimer {
  hours: string
  minutes: string
  seconds: string
  stopTimer: () => void
}

const useTimer = (timer: any): IUseTimer => {
  const [date] = useState(new Date())
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null)

  const [hours, setHours] = useState<number>(0)
  const [minutes, setMinutes] = useState<number>(0)
  const [seconds, setSeconds] = useState<number>(0)

  useEffect(() => {
    if (timer === null) return
    const hours = timer.split(':')[0]
    const minutes = timer.split(':')[1]
    const seconds = timer.split(':')[2]
    setHours(parseInt(hours))
    setMinutes(parseInt(minutes))
    setSeconds(parseInt(seconds))
  }, [timer])

  const stopTimer = useCallback(() => {
    if (intervalId !== null) {
      clearInterval(intervalId)
    }
  }, [intervalId])

  if (timer !== null) return { hours: getTwoDigits(hours), minutes: getTwoDigits(minutes), seconds: getTwoDigits(seconds), stopTimer }

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date()
      const diff = now.getTime() - date.getTime()
      const hours = Math.floor(diff / 1000 / 60 / 60)
      const minutes = Math.floor((diff / 1000 / 60) % 60)
      const seconds = Math.floor((diff / 1000) % 60)
      setHours(hours)
      setMinutes(minutes)
      setSeconds(seconds)
    }, 1000)
    setIntervalId(interval)
    return () => {
      clearInterval(interval)
    }
  }, [date])

  return { hours: getTwoDigits(hours), minutes: getTwoDigits(minutes), seconds: getTwoDigits(seconds), stopTimer }
}

export default useTimer

const getTwoDigits = (number: number): string => {
  return number < 10 ? `0${number}` : number.toString()
}
